import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import { toast } from "react-toastify";

export default function ContractVersionPane({ contractId, refreshKey = 0 }) {
  const [versions, setVersions] = useState([]);
  const [activeVersion, setActiveVersion] = useState(null);
  const [pendingVersion, setPendingVersion] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadVersions = () => {
    if (!contractId) return;
    axios
      .get(API + `contracts/contracts/${contractId}/versions/`, { headers: authHeader() })
      .then((res) => {
        const all = res.data.versions || [];
        setVersions(all);
         const versions = res.data.versions || [];

          setVersions(versions);

          // active version
          setActiveVersion(versions.find(v => v.is_active));
        // setActiveVersion(all.find((v) => v.is_active));
        // setPendingVersion(all.find((v) => v.status === "PendingApproval"));
        const pending = versions
        .filter(v => v.status === "ContractMod")
        .sort((a, b) => b.version - a.version)[0];
         setPendingVersion(pending || null);
        // setPendingVersion(all.find((v) => v.status === "ContractMod"));
      })
      .catch((err) => {
        console.error("Failed to load versions", err);
      });
  };

  const loadPaymentDetailsForVersion = (versionId) => {
    if (!versionId) return;
    setLoading(true);
    axios
      .get(API + `contracts/contracts/payment-details/${versionId}/`, { headers: authHeader() })
      .then((res) => {
        setRows(res.data || []);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadVersions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId, refreshKey]);

  useEffect(() => {
    if (pendingVersion) {
      loadPaymentDetailsForVersion(pendingVersion.id);
    } else {
      setRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingVersion]);

  const approve = async () => {
    if (!pendingVersion) return;
    try {
      await axios.post(API + `contracts/contracts/${contractId}/approve/${pendingVersion.version}/`, {}, { headers: authHeader() });
      toast.success("Version approved!");
      loadVersions();
    } catch (err) {
      console.error(err);
      toast.error("Failed to approve version");
    }
  };

  const reject = async () => {
    if (!pendingVersion) return;
    try {
      await axios.post(API + `contracts/${contractId}/reject/${pendingVersion.version}/`, {}, { headers: authHeader() });
      toast.warning("Version rejected");
      loadVersions();
    } catch (err) {
      console.error(err);
      toast.error("Failed to reject version");
    }
  };

  return (
    <div className="mt-4">
      {/* {activeVersion && <div className="alert alert-success">Active Version: v{activeVersion.version}</div>} */}

      {/* {pendingVersion && <div className="alert alert-warning">Pending Draft Version: v{pendingVersion.version}</div>} */}

      {pendingVersion ? (
        <>
          {/* <MaterialTable
            title="Preview Pending Payment Schedule"
            isLoading={loading}
            columns={[
              { title: "Payment Date", field: "paymentdate", editable: "never" },
              { title: "Amount", field: "periodicamount", type: "numeric", editable: "never" },
              {
                title: "Historical",
                field: "is_historical",
                render: (row) => (row.is_historical ? <span className="badge bg-secondary">Historical</span> : <span className="badge bg-primary">Modified</span>),
              },
              { title: "Version", field: "version" },
            ]}
            data={rows}
            options={{ search: false, paging: false, rowStyle: (rowData) => ({ background: rowData.is_historical ? "#f3f3f3" : "#e8f4ff" }) }}
          /> */}

          {/* <div className="d-flex justify-content-end mt-3">
            <button className="btn btn-secondary me-2" onClick={reject}>
              Cancel Draft
            </button>
            <button className="btn btn-primary" onClick={approve}>
               Activate
            </button>
          </div> */}
        </>
      ) : (
        <div className="alert alert-info">No pending modifications found.</div>
      )}
    </div>
  );
}
